import { createScopedTranslationKeys } from '@dreryk/react-common';

export const translations = {
   pl: {
      '~libs.desktop.shared.appointment': {
         appointmentBeginDate: 'Data wizyty',
         noteManagement: {
            create: {
               action: {
                  label: 'Dodaj notatkę',
               },
               label: 'Dodaj notatkę do wizyty',
            },
            form: {
               note: {
                  label: 'Treść notatki',
               },
            },
            placeholder: 'Uzupełnij treść notatki...',
            tooltipLabel: 'Notatka do wizyty',
            update: {
               action: {
                  label: 'Edytuj notatkę',
                  successful: {
                     withContent: 'Notatka została zapisana.',
                     withoutContent: 'Zapisano pustą notatkę.',
                  },
               },
               label: 'Edytuj notatkę do wizyty',
            },
         },
         patient: 'Pacjent',
         practitioner: 'Specjalista',
         specializations: 'specjalizacje',
      },
   },
};

export const translationKeys = createScopedTranslationKeys(translations.pl, '~libs.desktop.shared.appointment');
